'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var checkForNotNull = function checkForNotNull(obj) {
  if (!obj) {
    return false;
  }
  if (obj instanceof Array) {
    return obj.reduce(function (result, o) {
      if (result || checkForNotNull(o)) {
        return true;
      }return false;
    }, false);
  } else if (obj instanceof Object) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    }).reduce(function (result, o) {
      if (result || checkForNotNull(o)) {
        return true;
      }return false;
    }, false);
  }
  return obj != null;
};

var SubmitButton = function SubmitButton(_ref, _ref2) {
  var renderSubmitButton = _ref.renderSubmitButton,
      invalid = _ref.invalid,
      submitting = _ref.submitting,
      submitForm = _ref.submitForm,
      hasChanges = _ref.hasChanges,
      hasWarnings = _ref.hasWarnings,
      asyncValidating = _ref.asyncValidating,
      props = _objectWithoutProperties(_ref, ['renderSubmitButton', 'invalid', 'submitting', 'submitForm', 'hasChanges', 'hasWarnings', 'asyncValidating']);

  var submit = _ref2.submit;

  return renderSubmitButton(_extends({}, props, { submit: submit || submitForm, invalid: invalid, submitting: submitting, hasChanges: hasChanges, hasWarnings: hasWarnings, asyncValidating: asyncValidating }));
};

SubmitButton.contextTypes = {
  submit: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var warnings = (0, _reduxForm.getFormSyncWarnings)(ownProps.name)(state);
  console.log('Warning are:', warnings, checkForNotNull(warnings));

  return {
    hasWarnings: checkForNotNull(warnings),
    invalid: (0, _reduxForm.isInvalid)(ownProps.name)(state),
    submitting: (0, _reduxForm.isSubmitting)(ownProps.name)(state),
    hasChanges: (0, _reduxForm.isDirty)(ownProps.name)(state),
    asyncValidating: !!(state.form[ownProps.name] && state.form[ownProps.name].asyncValidating)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    submitForm: function submitForm() {
      return dispatch((0, _reduxForm.submit)(ownProps.name));
    }
  };
};

SubmitButton = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SubmitButton);

var SubmitFormButton = function SubmitFormButton(props, _ref3) {
  var formName = _ref3.formName;
  return _react2.default.createElement(SubmitButton, _extends({ name: formName }, props));
};

SubmitFormButton.contextTypes = {
  formName: _propTypes2.default.string
};

exports.default = SubmitFormButton;